<template>
  <div class="container">
    <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/header2.webp" fit="fill" lazy-load show-loading />
    <div class="content" id="input-top">
      <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/title3.webp" fit="fill" lazy-load show-loading />
      <div class="con-form">
        <div class="con-form-one">
          <van-field
            label="贷款人姓名"
            v-model="form.lenderName"
            :onkeyup="getLenderName(form.lenderName)"
            input-align="right"
            placeholder="请填写贷款人姓名"
          >
          </van-field>
          <van-field label="贷款人年龄" v-model="form.lenderAge" type="number" input-align="right" placeholder="请填写贷款人年龄">
            <template #extra>
              <p style="margin-left: 5px">岁</p>
            </template>
          </van-field>
          <van-cell
            title="贷款人婚姻状况"
            is-link
            :value="form.marry.text ? form.marry.text : '请选择婚姻状况'"
            :value-class="form.marry.text ? 'selected' : ''"
            @click="openVanPopup('marry', marryList)"
          />
          <van-cell
            title="贷款人所在地"
            is-link
            :value="form.lenderLocation[0] ? form.lenderLocation[0].name + form.lenderLocation[1].name + form.lenderLocation[2].name : '请选择所在地'"
            :value-class="form.lenderLocation[0] ? 'selected' : ''"
            @click="openVanPopup('lenderLocation', areaList)"
          />
        </div>
        <div class="con-form-two">
          <van-cell
            title="设备类型"
            is-link
            :value="form.deviceType.text ? form.deviceType.text : '请选择设备类型'"
            :value-class="form.deviceType.text ? 'selected' : ''"
            @click="openVanPopup('deviceType', deviceTypeList)"
          />
          <van-field label="设备金额" v-model="form.deviceAmount" type="number" input-align="right" placeholder="请填写设备金额">
            <template #extra>
              <p style="margin-left: 5px">万元</p>
            </template>
          </van-field>
          <van-cell
            title="设备所在地"
            is-link
            :value="
              form.deviceLocation[0] ? form.deviceLocation[0].name + form.deviceLocation[1].name + form.deviceLocation[2].name : '请选择设备所在地'
            "
            :value-class="form.deviceLocation[0] ? 'selected' : ''"
            @click="openVanPopup('deviceLocation', areaList)"
          />
          <van-cell
            title="卖方类型"
            is-link
            :value="form.sellerType.text ? form.sellerType.text : '请选择卖方类型'"
            :value-class="form.sellerType.text ? 'selected' : ''"
            @click="openVanPopup('sellerType', sellType)"
          />
          <van-button type="primary" color="#FFD23C" class="btn-style" @click="submit">立即提交</van-button>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-image class="img-block" src="https://yunlian-oss-product.oss-cn-hangzhou.aliyuncs.com/h5/product.webp" fit="fill" lazy-load show-loading />
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-area
        v-if="type == 'deviceLocation' || type == 'lenderLocation'"
        title="标题"
        :area-list="columnsList"
        @confirm="onConfirm"
        @cancel="show = false"
      />
      <van-picker
        v-else
        ref="picker"
        show-toolbar
        :title="titleObj[type]"
        :columns="columnsList"
        value-key="text"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data"
export default {
  name: "customer",
  components: {},
  data() {
    return {
      show: false,
      type: "",
      checkTime: "",
      submitterPhone: "",
      submitterType: "",
      uid: "",
      marryList: [
        {
          text: "已婚",
          value: 0
        },
        {
          text: "未婚",
          value: 1
        },
        {
          text: "不详",
          value: 2
        }
      ],
      areaList: areaList,
      deviceTypeList: [],
      sellType: [
        {
          text: "代理商",
          value: 1
        },
        {
          text: "车商",
          value: 2
        },
        {
          text: "终端用户",
          value: 3
        }
      ],
      columnsList: [],
      titleObj: {
        marry: "贷款人婚姻情况",
        lenderLocation: "贷款人所在地",
        deviceLocation: "设备所在地",
        deviceType: "设备类型",
        sellerType: "卖方类型"
      },
      form: {
        lenderName: "",
        lenderAge: "",
        marry: {},
        lenderLocation: [],
        deviceType: {},
        deviceAmount: "",
        deviceLocation: [],
        sellerType: {}
      }
    }
  },
  created() {
    document.title = "三一云联金服1号"
    let params = this.$route.query
    this.checkTime = params.checkTime
    this.submitterPhone = params.phone
    this.submitterType = params.roleType
    this.uid = params.uid
    this.$api.getDeviceType().then((res) => {
      this.deviceTypeList = []
      if (res.data) {
        res.data.data.types.forEach((item) => {
          this.deviceTypeList.push({
            text: item.typeName,
            value: item.typeId
          })
        })
      }
    })
  },
  mounted() {
    document.body.addEventListener("focusin", (e) => {
      if (e.target.localName == "input" && document.getElementById("input-top")) {
        document.getElementById("input-top").scrollIntoView(true)
      }
    })
  },
  methods: {
    openVanPopup(type, list) {
      this.show = true
      this.columnsList = list
      this.type = type
    },
    getLenderName(value) {
      this.form.lenderName = value.replace(/[0-9]/g, "")
    },
    onConfirm(e) {
      this.form[this.type] = e
      this.show = false
    },
    submit() {
      if (!this.form.lenderName) {
        this.$toast({ message: "请填写贷款人姓名", position: "bottom" })
        return
      }
      if (this.form.lenderName.length > 10) {
        this.$toast({ message: "贷款人姓名长度不能超过10位", position: "bottom" })
        return
      }
      if (!this.form.lenderAge) {
        this.$toast({ message: "请填写贷款人年龄", position: "bottom" })
        return
      }
      if (this.form.lenderAge > 99 || this.form.lenderAge < 18 || this.form.lenderAge.indexOf(".") != -1) {
        this.$toast({ message: "贷款人年龄应为18-99的正整数", position: "bottom" })
        return
      }
      if (!this.form.marry.text) {
        this.$toast({ message: "请选择婚姻状况", position: "bottom" })
        return
      }
      if (!this.form.lenderLocation[2]) {
        this.$toast({ message: "请选择贷款人所在地", position: "bottom" })
        return
      }
      if (!this.form.deviceType.value) {
        this.$toast({ message: "请选择设备类型", position: "bottom" })
        return
      }
      if (!this.form.deviceAmount) {
        this.$toast({ message: "请填写设备金额", position: "bottom" })
        return
      }
      if (this.form.deviceAmount.indexOf("-") != -1) {
        this.$toast({ message: "请填写正确的设备金额", position: "bottom" })
        return
      }
      if (this.form.deviceAmount <= 0) {
        this.$toast({ message: "设备金额不能为负", position: "bottom" })
        return
      }
      if (this.form.deviceAmount.split(".")[1] && this.form.deviceAmount.split(".")[1].length > 4) {
        this.$toast({ message: "设备金额最多四位小数", position: "bottom" })
        return
      }
      if (!this.form.deviceLocation[2]) {
        this.$toast({ message: "请选择设备所在地", position: "bottom" })
        return
      }
      const data = {
        checkTime: this.checkTime,
        lenderName: this.form.lenderName,
        lenderAge: this.form.lenderAge * 1,
        isMarry: this.form.marry.value,
        lenderLocation: this.form.lenderLocation[0].name + this.form.lenderLocation[1].name + this.form.lenderLocation[2].name,
        deviceTypeId: this.form.deviceType.value,
        deviceType: this.form.deviceType.text,
        deviceAmount: this.form.deviceAmount * 1,
        deviceLocation: this.form.deviceLocation[0].name + this.form.deviceLocation[1].name + this.form.deviceLocation[2].name,
        sellerType: this.form.sellerType.value || ""
      }
      //调用flutter 关闭页面
      // FlutterApp.postMessage(AppConfig.CLOSE_PAGE);
      // return;
      this.$api.customerSubmit(data).then((res) => {
        if (res.data.code == 0) {
          this.$toast({ message: "提交成功", position: "bottom" })
          //   向app发送消息
          this.$router.replace({
            path: "/business",
            query: {
              phone: this.submitterPhone,
              roleType: this.submitterType,
              uid: this.uid
            }
          })
          this.$router.go(-1)
          // if (window["_APP_ACTION_openPage"]) {
          //   window["_APP_ACTION_openPage"].postMessage('{"action":"pop","webId":"finance"}');
          // }
          // this.$router.replace({
          //   path: "/business",
          //   query: {
          //     phone: this.submitterPhone,
          //     roleType: this.submitterType,
          //     uid: this.uid,
          //   },
          // });
        } else {
          this.$toast({ message: "提交失败", position: "bottom" })
        }
      })
    }
  },
  watch: {}
}
</script>
<style lang="scss">
.container {
  .van-cell {
    background: #ffffff;
    margin-top: 0;
  }
  .van-field__label {
    color: #323233;
  }
}
</style>
<style lang="scss" scoped>
.container {
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: #f8f2df;
  .van-cell__title {
    flex: 1;
    text-align: left;
  }
  .selected {
    color: #323233;
  }
  .content {
    position: relative;
    text-align: center;
    margin: 15px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 10px;
    margin-top: -100px;
    .con-form {
      background-color: #f6f7f9;
      .van-cell__value {
        color: #ccc;
        font-size: 14px;
      }
      .selected {
        color: #000;
      }
    }
    .con-form-one,
    .con-form-two {
      background-color: #fff;
      margin-bottom: 10px;
    }
    .con-form-two {
      padding-bottom: 30px;
    }
    .btn-style {
      width: 70%;
      margin-top: 20px;
      color: #852900 !important;
      font-weight: bold;
      border-radius: 24px;
      font-size: 16px;
    }
  }
  .bottom {
    margin: 15px;
    box-sizing: border-box;
    padding-bottom: 15px;
  }
}
</style>
